import {ChangeDetectorRef, Component, Injector, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {CardApiService} from '@modules/equipment-card/services/card.api.service';
import {AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';
import {ModalComponent} from '@components/modal/modal.component';
import {EquipmentControlService} from '../../services/equipment-control.service';
import {untilDestroyed} from 'ngx-take-until-destroy';

@Component({
    selector: 'app-calibration-request-modal',
    templateUrl: './calibration-request-modal.component.html',
})
export class CalibrationRequestModalComponent extends FrontendFormComponent implements OnDestroy {

    @Input() cardIds: number[] = [];

    @Input() showOfferFields = true;

    @Input() equipmentTitle: string;

    @ViewChild(ModalComponent) private modal: ModalComponent;

    public form = this._fb.group({
        is_allowed: [false],
        request: this._fb.group({
            card_ids: [],
            is_only_state_facilities: [false],
            name: [],
            phone: [],
            email: [],
        })
    });

    constructor(
        public formService: CardApiService,
        private controlService: EquipmentControlService,
        private cd: ChangeDetectorRef,
        private ajaxDownloadService: AjaxDownloadService,
        injector: Injector
    ) {
        super(injector);
    }

    get saveUrl() {
        return this.formService.validateRequestCalibrationDocumentUrl;
    }

    init() {
        this.setDefaultFormValues();

        this.controlService.showCalibrationRequestDialog$.pipe(
            untilDestroyed(this)
        ).subscribe(() => {
            this.cd.reattach();
            this.modal.open();
        });

        this.cd.detach();
    }

    beforeSave() {
        this.form.get('request.card_ids').patchValue(this.cardIds);
    }

    get isAllowed(): boolean {
        return this.form.get('is_allowed').value;
    }

    afterSave(downloadUrl: string): void {
        this.ajaxDownloadService.do({
            method: 'post',
            url: this.formService.generateRequestCalibrationDocumentUrl,
            data: this.form.getRawValue(),
            taskName: 'Заявка на поверку',
        });
        this.modal.close();
    }

    ngOnDestroy(): void {

    }

    onModalClose() {
        this.isPending = false;
        this.setDefaultFormValues();
        this.cd.detach();
    }

    private setDefaultFormValues() {
        this.form.patchValue({
            is_allowed: this.showOfferFields,
            request: {
                card_ids: null,
                is_only_state_facilities: false,
                name: null,
                phone: null,
                email: null,
            }
        });
    }
}
